import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconDocumentTextOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="m15.593 0 6.08 6.76V24H3V0zM14.39 1.403H4.403v21.194h15.866V7.647H14.39zM18 16.5V18H7.5v-1.5zm0-4.5v1.5H7.5V12zM15.793 1.992v4.621h3.786z" /></svg>
);
